module.exports = __webpack_public_path__ + "static/media/Gilroy-SemiBold.05bdf30b.ttf";